import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M15.75 1.5 14.25 3m0 0 2.25 2.25-2.625 2.625-2.25-2.25M14.25 3l-2.625 2.625M8.543 8.707a4.125 4.125 0 1 1-5.834 5.834 4.125 4.125 0 0 1 5.833-5.833zm0 0 3.082-3.082"
    }, null, -1)
  ]))]))
}
export default { render: render }